@if (data.loadingSpinner) {
  <mat-spinner color="accent" [diameter]="30"></mat-spinner>
}
@if (data.icon) {
  <mat-icon>{{ data.icon }}</mat-icon>
}

<span>{{ data.message }}</span>

@if (data.dismissButton) {
  <button color="accent" (click)="dismissClick()" mat-button>Ok</button>
}
